"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.name.placeholder': 'Enter project name',
};
